// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MarketFilterMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MarketFilterMetadataQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string }> };


export const MarketFilterMetadataDocument = gql`
    query MarketFilterMetadata {
  markets {
    id
    name
  }
}
    `;

/**
 * __useMarketFilterMetadataQuery__
 *
 * To run a query within a React component, call `useMarketFilterMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketFilterMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketFilterMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketFilterMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>(MarketFilterMetadataDocument, options);
      }
export function useMarketFilterMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>(MarketFilterMetadataDocument, options);
        }
// @ts-ignore
export function useMarketFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>;
export function useMarketFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarketFilterMetadataQuery | undefined, MarketFilterMetadataQueryVariables>;
export function useMarketFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>(MarketFilterMetadataDocument, options);
        }
export type MarketFilterMetadataQueryHookResult = ReturnType<typeof useMarketFilterMetadataQuery>;
export type MarketFilterMetadataLazyQueryHookResult = ReturnType<typeof useMarketFilterMetadataLazyQuery>;
export type MarketFilterMetadataSuspenseQueryHookResult = ReturnType<typeof useMarketFilterMetadataSuspenseQuery>;
export type MarketFilterMetadataQueryResult = Apollo.QueryResult<MarketFilterMetadataQuery, MarketFilterMetadataQueryVariables>;